// Location constants shared across the module

export const VENUE_TYPES = {
  salon:              { label: 'Salón',                emoji: '🏛', icon: 'building' },
  estadio:            { label: 'Estadio',              emoji: '🏟', icon: 'map-pin'  },
  auditorio:          { label: 'Auditorio',            emoji: '🎭', icon: 'mic'      },
  centro_convenciones:{ label: 'Centro de Convenciones',emoji: '🏢', icon: 'layers'  },
  explanada_abierta:  { label: 'Explanada Abierta',    emoji: '🌿', icon: 'tree'     },
};

export const STATUS_CONFIG = {
  activa:           { label: 'Activa',           bg: 'bg-green-100 text-green-800 border-green-200',   dot: 'bg-green-600'  },
  en_mantenimiento: { label: 'En Mantenimiento', bg: 'bg-orange-100 text-orange-800 border-orange-200', dot: 'bg-orange-500' },
  inactiva:         { label: 'Inactiva',         bg: 'bg-slate-100 text-slate-600 border-slate-300',   dot: 'bg-slate-400'  },
};

export const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

export const EXTERNAL_API = process.env.REACT_APP_API_URL?.replace(/\/api$/, '') || '';
